import { ColDef } from "ag-grid-community";
import { amountColumnTemplate, currencyComparator, dateComparator, dateComparatorForFilter, sharedColNames } from "./table-helpers";
import { agFilterNames } from "../../../shared/types/AgFilterNames";

const colNames = {
  date: 'Transaction date',
  nextTransactionDate: 'Next transaction date',
  frequency: 'Frequency',
  amount: 'Amount',
  toFromAccount: sharedColNames.toFromAccount,
  transactionType: sharedColNames.transactionType,
  actions: sharedColNames.actions,
  status: 'Status',
  nickname: 'Nickname',
  recipientName: 'Recipient name',
  bankName: 'Bank name',
  accountNumber: 'Account number',
  dateCreated: 'Date created',
  IncomingOutgoing: 'Direction'
}

export const defaultAllTabColumnDefs: ColDef[] = [
  {
    field: colNames.transactionType,
    sort: null,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.IncomingOutgoing,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.toFromAccount,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.amount,
    comparator: currencyComparator,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    type: 'rightAligned',
    headerComponentParams: { template: amountColumnTemplate },
    minWidth: 120,
    width: 120,
    maxWidth: 140
  },
  {
    field: colNames.date,
    sort: 'asc', //explicitly specify null to avoid sorting second column
    comparator: dateComparator,
    filter: agFilterNames.date,
    filterParams: {
      comparator: dateComparatorForFilter,
      inRangeInclusive: true,
      browserDatePicker: true
    },
    minWidth: 160,
    maxWidth: 160
  },
  {
    field: colNames.frequency,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    minWidth: 120,
    width: 120,
    maxWidth: 130
  },
  {
    field: colNames.status,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    width: 120,
    minWidth: 120,
    maxWidth: 130
  }
];

export const defaultUpcomingTabColumnDefs: ColDef[] = [
  {
    field: colNames.transactionType,
    sort: null,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.IncomingOutgoing,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.toFromAccount,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.amount,
    comparator: currencyComparator,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    type: 'rightAligned',
    headerComponentParams: { template: amountColumnTemplate },
    minWidth: 120,
    width: 120,
    maxWidth: 140
  },
  {
    field: colNames.date,
    sort: 'asc', //explicitly specify null to avoid sorting second column
    comparator: dateComparator,
    filter: agFilterNames.date,
    filterParams: {
      comparator: dateComparatorForFilter,
      inRangeInclusive: true,
      browserDatePicker: true
    },
    minWidth: 160,
    maxWidth: 160
  },
  {
    field: colNames.frequency,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    minWidth: 120,
    width: 120,
    maxWidth: 130
  }
];

export const defaultRecentTabColumnDefs: ColDef[] = [
  {
    field: colNames.transactionType,
    sort: null,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.IncomingOutgoing,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.toFromAccount,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.amount,
    comparator: currencyComparator,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    type: 'rightAligned',
    headerComponentParams: { template: amountColumnTemplate },
    minWidth: 120,
    width: 120,
    maxWidth: 140
  },
  {
    field: colNames.date,
    sort: 'asc', //explicitly specify null to avoid sorting second column
    comparator: dateComparator,
    filter: agFilterNames.date,
    filterParams: {
      comparator: dateComparatorForFilter,
      inRangeInclusive: true,
      browserDatePicker: true
    },
    minWidth: 160,
    maxWidth: 160
  },
  {
    field: colNames.frequency,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    minWidth: 120,
    width: 120,
    maxWidth: 130
  },
  {
    field: colNames.status,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    width: 120,
    minWidth: 120,
    maxWidth: 130
  }
];

export const defaultRecurringTabColumnDefs: ColDef[] = [
  {
    field: colNames.transactionType,
    sort: null,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.IncomingOutgoing,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120
  },
  {
    field: colNames.toFromAccount,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: colNames.amount,
    comparator: currencyComparator,
    floatingFilterComponent: 'customTextFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    type: 'rightAligned',
    headerComponentParams: { template: amountColumnTemplate },
    minWidth: 120,
    width: 120,
    maxWidth: 140
  },
  {
    field: colNames.nextTransactionDate,
    comparator: dateComparator,
    filter: agFilterNames.date,
    filterParams: {
      comparator: dateComparatorForFilter,
      inRangeInclusive: true,
      browserDatePicker: true
    },
    minWidth: 170,
    maxWidth: 180
  },
  {
    field: colNames.frequency,
    filter: agFilterNames.set,
    floatingFilterComponent: 'customSetFloatingFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
    minWidth: 120,
    width: 120,
    maxWidth: 130
  }
];
